import { Component, AfterViewInit, OnDestroy } from '@angular/core';


import * as $ from 'jquery';

@Component({
    selector: 'blank-view',
    templateUrl: './blank.view.html',
    styleUrls: ['./blank.view.css'],
})
export class BlankView implements AfterViewInit, OnDestroy {

    ngAfterViewInit() {
        $('body').addClass('gray-bg');
    }

    ngOnDestroy() {
        $('body').removeClass('gray-bg');
    }
}
